export const environment = {
  production: false,
  apiUrl: 'https://dev.dymly.com/api/',
  s3url: 'https://dymlyprofileimages.fra1.digitaloceanspaces.com'
};
